import path_45params from "/opt/buildhome/repo/modules/router/runtime/path.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.1_better-sqlite3@11.9.1_db0@0.3.1_b_89c3fd137d081d32b88f857718342659/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  path_45params,
  manifest_45route_45rule
]
export const namedMiddleware = {}